module.exports = __webpack_public_path__ + "media/images/category/dummy/hat03-1a2fe7eaca2a34b50534eff55af5ca16.jpg";